/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import PatientsPatientEthnicities from './PatientsPatientEthnicities';
import PatientsPatientRaces from './PatientsPatientRaces';
import PractitionersinvitePractitionerRenderingNpiAttributes from './PractitionersinvitePractitionerRenderingNpiAttributes';

/**
 * The PractitionersinvitePractitioner model module.
 * @module model/PractitionersinvitePractitioner
 * @version v0.3
 */
export default class PractitionersinvitePractitioner {
  /**
   * Constructs a new <code>PractitionersinvitePractitioner</code>.
   * @alias module:model/PractitionersinvitePractitioner
   * @class
   * @param email {String} 
   */
  constructor(email) {
    this.email = email;
  }

  /**
   * Constructs a <code>PractitionersinvitePractitioner</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PractitionersinvitePractitioner} obj Optional instance to populate.
   * @return {module:model/PractitionersinvitePractitioner} The populated <code>PractitionersinvitePractitioner</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PractitionersinvitePractitioner();
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
      if (data.hasOwnProperty('first_name'))
        obj.firstName = ApiClient.convertToType(data['first_name'], 'String');
      if (data.hasOwnProperty('middle_name'))
        obj.middleName = ApiClient.convertToType(data['middle_name'], 'String');
      if (data.hasOwnProperty('last_name'))
        obj.lastName = ApiClient.convertToType(data['last_name'], 'String');
      if (data.hasOwnProperty('biography'))
        obj.biography = ApiClient.convertToType(data['biography'], 'String');
      if (data.hasOwnProperty('birth_date'))
        obj.birthDate = ApiClient.convertToType(data['birth_date'], 'Date');
      if (data.hasOwnProperty('gender_identity'))
        obj.genderIdentity = ApiClient.convertToType(data['gender_identity'], 'String');
      if (data.hasOwnProperty('administrative_gender'))
        obj.administrativeGender = ApiClient.convertToType(data['administrative_gender'], 'String');
      if (data.hasOwnProperty('external_id'))
        obj.externalId = ApiClient.convertToType(data['external_id'], 'String');
      if (data.hasOwnProperty('confirmation_url'))
        obj.confirmationUrl = ApiClient.convertToType(data['confirmation_url'], 'String');
      if (data.hasOwnProperty('organization_ids'))
        obj.organizationIds = ApiClient.convertToType(data['organization_ids'], ['String']);
      if (data.hasOwnProperty('races'))
        obj.races = ApiClient.convertToType(data['races'], [PatientsPatientRaces]);
      if (data.hasOwnProperty('ethnicities'))
        obj.ethnicities = ApiClient.convertToType(data['ethnicities'], [PatientsPatientEthnicities]);
      if (data.hasOwnProperty('tag_list'))
        obj.tagList = ApiClient.convertToType(data['tag_list'], ['String']);
      if (data.hasOwnProperty('metadata'))
        obj.metadata = ApiClient.convertToType(data['metadata'], {'String': Object});
      if (data.hasOwnProperty('rendering_npi_attributes'))
        obj.renderingNpiAttributes = PractitionersinvitePractitionerRenderingNpiAttributes.constructFromObject(data['rendering_npi_attributes']);
    }
    return obj;
  }
}

/**
 * @member {String} email
 */
PractitionersinvitePractitioner.prototype.email = undefined;

/**
 * @member {String} firstName
 */
PractitionersinvitePractitioner.prototype.firstName = undefined;

/**
 * @member {String} middleName
 */
PractitionersinvitePractitioner.prototype.middleName = undefined;

/**
 * @member {String} lastName
 */
PractitionersinvitePractitioner.prototype.lastName = undefined;

/**
 * @member {String} biography
 */
PractitionersinvitePractitioner.prototype.biography = undefined;

/**
 * yyyy-mm-dd (ISO 8601)
 * @member {Date} birthDate
 */
PractitionersinvitePractitioner.prototype.birthDate = undefined;

/**
 * Allowed values for the <code>genderIdentity</code> property.
 * @enum {String}
 * @readonly
 */
PractitionersinvitePractitioner.GenderIdentityEnum = {
  /**
   * value: "female"
   * @const
   */
  female: "female",

  /**
   * value: "male"
   * @const
   */
  male: "male",

  /**
   * value: "non_binary"
   * @const
   */
  nonBinary: "non_binary",

  /**
   * value: "non_disclose"
   * @const
   */
  nonDisclose: "non_disclose",

  /**
   * value: "other"
   * @const
   */
  other: "other",

  /**
   * value: "transgender_female"
   * @const
   */
  transgenderFemale: "transgender_female",

  /**
   * value: "transgender_male"
   * @const
   */
  transgenderMale: "transgender_male"
};
/**
 * The gender the practitioner identifies with.
 * @member {module:model/PractitionersinvitePractitioner.GenderIdentityEnum} genderIdentity
 */
PractitionersinvitePractitioner.prototype.genderIdentity = undefined;

/**
 * Allowed values for the <code>administrativeGender</code> property.
 * @enum {String}
 * @readonly
 */
PractitionersinvitePractitioner.AdministrativeGenderEnum = {
  /**
   * value: "unknown"
   * @const
   */
  unknown: "unknown",

  /**
   * value: "male"
   * @const
   */
  male: "male",

  /**
   * value: "female"
   * @const
   */
  female: "female",

  /**
   * value: "not_applicable"
   * @const
   */
  notApplicable: "not_applicable"
};
/**
 * The gender of the practitioner to be used for administrative purposes.
 * @member {module:model/PractitionersinvitePractitioner.AdministrativeGenderEnum} administrativeGender
 */
PractitionersinvitePractitioner.prototype.administrativeGender = undefined;

/**
 * @member {String} externalId
 */
PractitionersinvitePractitioner.prototype.externalId = undefined;

/**
 * @member {String} confirmationUrl
 */
PractitionersinvitePractitioner.prototype.confirmationUrl = undefined;

/**
 * Associate the practitioner with organizations.
 * @member {Array.<String>} organizationIds
 */
PractitionersinvitePractitioner.prototype.organizationIds = undefined;

/**
 * The practitioner's race as identified by the practitioner.
 * @member {Array.<module:model/PatientsPatientRaces>} races
 */
PractitionersinvitePractitioner.prototype.races = undefined;

/**
 * The practitioner's ethnicity as identified by the practitioner.
 * @member {Array.<module:model/PatientsPatientEthnicities>} ethnicities
 */
PractitionersinvitePractitioner.prototype.ethnicities = undefined;

/**
 * Add an array of strings to help manage your resources
 * @member {Array.<String>} tagList
 */
PractitionersinvitePractitioner.prototype.tagList = undefined;

/**
 * Any JSON-formatted data you want to associate with this object
 * @member {Object.<String, Object>} metadata
 */
PractitionersinvitePractitioner.prototype.metadata = undefined;

/**
 * @member {module:model/PractitionersinvitePractitionerRenderingNpiAttributes} renderingNpiAttributes
 */
PractitionersinvitePractitioner.prototype.renderingNpiAttributes = undefined;

